import React from "react";
import "./Loader.css"

const Loader = () => {

    return <div className="body">
        <div class="LoaderBalls ">
            <div class="LoaderBalls__item"></div>
            <div class="LoaderBalls__item"></div>
            <div class="LoaderBalls__item"></div>
        </div>
    </div>
}

export default Loader